import React from 'react';

export default () => {
  return (
    <div>
      succeed
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/confirmation/success-template.js